module.exports = __webpack_public_path__ + "img/uy.31bef519.svg";